/**
 * Clip a number between min and max.
 *
 * @param {Number} min
 *   The minimum return value.
 * @param {Number} max
 *   The maximum return value.
 * @param {Number} val
 *   The value to aim for.
 * @return {Number}
 *   If val is less than min, then min.
 *   If val is more than max, then max.
 *   Otherwise, val.
 */
export function minMax(min: number, max: number, val: number): number {
  if (val < min) {
    return min;
  }
  if (val > max) {
    return max;
  }
  return val;
}
